module.exports = __webpack_public_path__ + "26bd5742d43522644908d8eae007baa1.woff2";